import { render, staticRenderFns } from "./ViewSessionWithSubs.vue?vue&type=template&id=23d5a85a&scoped=true&lang=pug&"
import script from "./ViewSessionWithSubs.vue?vue&type=script&lang=js&"
export * from "./ViewSessionWithSubs.vue?vue&type=script&lang=js&"
import style0 from "./ViewSessionWithSubs.vue?vue&type=style&index=0&id=23d5a85a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d5a85a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
